export default "__VITE_ASSET__DK9j0VR0__"